import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'titlecase', pure: false })
/** Transform to Title Case: uppercase the first letter of the words in a string.*/
export class TitleCasePipe implements PipeTransform {
  transform(input: string): string {
    let value = input;
    if (input.length === 0) {
      value = '';
    } else {
      value = value.replace(/\_/g, ' ');
      value = value.replace(/\w\S*/g, (txt => txt[0].toUpperCase() + txt.substr(1).toLowerCase()));
    }
    return value;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/title-case.pipe.ts